import * as React from "react";
import TechTreeButton from "./TechTreeButton/TechTreeButton";
import {drawTankTree} from "../../helpers/treeDraw";
import {toRoman, toEraString} from "../../helpers/helpers";

const TechTree = (props) => {

    const techTreeTitle = gettext("Tech Tree Position");

    const relativeGrouping = (data, currentVehicle) => {
        let fromVehicles = [],
            toVehicles = [];
        let toVehicleIds = [];
        let fromVehicleIds = [];
        let mappingBlocks;

        if (typeof data === 'object') {

            Object.keys(data).map(i => {
                const vehicle = data[i].vehicle;
                const vehicleMapTo = data[i].to_vehicle;

                if (vehicle.id === currentVehicle.id) {
                    if (toVehicleIds.indexOf(vehicleMapTo.id) < 0) {
                        toVehicles.push(vehicleMapTo);
                        toVehicleIds.push(vehicleMapTo.id);
                    }
                } else {
                    if (fromVehicleIds.indexOf(vehicle.id) < 0) {
                        vehicle.mapTo = currentVehicle.id;
                        fromVehicles.push(vehicle);
                        fromVehicleIds.push(vehicle.id);
                    }
                }
            })
        }
        currentVehicle.mapTo = toVehicleIds;
        mappingBlocks = [fromVehicles, [currentVehicle], toVehicles].filter(function(e) { return e.length > 0});
        return mappingBlocks
    };

    const element = {
            canvasClass: "js-tech-tree",
            itemClass: "js-tech-tree_box"
        };
    const canvas_style = {
        strokeColor: props.treeStrokeColor,
        padding: 10
    };

    drawTankTree(element, canvas_style);

    const mappingBlocks = relativeGrouping(props.data, props.currentVehicle);

    const numColumnsThreshold = 3;

    return (
        <section className="tank-tree">
            <div className="tank-tree_wrapper">
                <h3 className="tank-tree_title">{techTreeTitle}</h3>
                <div className="tank-tree_map js-tech-tree">
                    {
                        mappingBlocks.map((currentBlock, k) => {
                            return (
                                <div className="tank-tree_child" key={k}>
                                    {
                                        currentBlock.map((currentTank, idx) => {
                                            const {user_string, id, level, price, xp_cost, type_slug,
                                                   image_techtree_url, url, mapTo, era}  = currentTank;
                                            return (
                                                <TechTreeButton key={idx} value={id} name={user_string}
                                                                level={level ? toRoman(level) : toEraString(era)} price={price} exp={xp_cost}
                                                                type={type_slug.toLowerCase()} img={image_techtree_url}
                                                                tankUrl={url} mapping={mapTo}/>
                                            )
                                        })
                                    }
                                </div>
                            )
                        })
                    }
                    {
                        (mappingBlocks.length < numColumnsThreshold) &&
                        <div className="tank-tree_child tank-tree_child__empty" key={numColumnsThreshold}>
                        </div>
                    }
                </div>
            </div>
        </section>
    )
};
export default TechTree;